export interface Category {
  name: string;
  url: string;
  icon: string;
  description: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Find the latest sneakers, athletic shoes, and casual footwear from trusted sellers in the AcBuy spreadsheet.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20sneaker%20display%20on%20warm%20cream%20background%2C%20modern%20fashion%20footwear%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20white%20and%20neutral%20toned%20casual%20shoes&width=200&height=200&seq=cat-shoes-v2&orientation=squarish',
  },
  {
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    icon: 'ri-t-shirt-line',
    description: 'Browse hoodies and sweaters across all styles — streetwear, luxury, and everyday essentials.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20hoodie%20flat%20lay%20on%20warm%20cream%20background%2C%20soft%20textured%20fabric%2C%20neutral%20earth%20tone%2C%20clean%20modern%20aesthetic%2C%20editorial%20fashion%20photography&width=200&height=200&seq=cat-hoodies-v2&orientation=squarish',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    icon: 'ri-shirt-line',
    description: 'Discover graphic tees, plain basics, and designer t-shirts curated in the spreadsheet.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20t-shirt%20display%20on%20warm%20cream%20background%2C%20folded%20cotton%20tee%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20neutral%20white%20and%20beige%20tones&width=200&height=200&seq=cat-tshirts-v2&orientation=squarish',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    icon: 'ri-user-3-line',
    description: 'Shop jackets, coats, and outerwear from verified sellers with quality links.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20jacket%20display%20on%20warm%20cream%20background%2C%20stylish%20outerwear%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20photography%2C%20neutral%20tan%20and%20olive%20tones%2C%20clean%20composition&width=200&height=200&seq=cat-jackets-v2&orientation=squarish',
  },
  {
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    icon: 'ri-pantone-line',
    description: 'Explore pants, jeans, shorts, and trousers across all price ranges.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20trousers%20and%20shorts%20flat%20lay%20on%20warm%20cream%20background%2C%20soft%20fabric%20texture%2C%20neutral%20khaki%20and%20beige%20tones%2C%20editorial%20product%20photography&width=200&height=200&seq=cat-pants-v2&orientation=squarish',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    icon: 'ri-customer-service-2-line',
    description: 'Caps, beanies, bucket hats, and more — all organized in one spreadsheet.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20cap%20and%20beanie%20display%20on%20warm%20cream%20background%2C%20soft%20textured%20fabric%2C%20neutral%20tones%2C%20clean%20editorial%20photography%2C%20simple%20elegant%20composition&width=200&height=200&seq=cat-headwear-v2&orientation=squarish',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    icon: 'ri-stack-line',
    description: 'Matching sets, co-ord outfits, and full looks from top sellers.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20matching%20outfit%20set%20on%20warm%20cream%20background%2C%20coordinated%20fashion%20pieces%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20neutral%20and%20warm%20tones&width=200&height=200&seq=cat-sets-v2&orientation=squarish',
  },
  {
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    icon: 'ri-checkbox-blank-line',
    description: 'Essentials and basics — underwear and underpants from trusted sources.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20soft%20cotton%20fabric%20display%20on%20warm%20cream%20background%2C%20clean%20simple%20aesthetic%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20neutral%20white%20tones&width=200&height=200&seq=cat-underwear-v2&orientation=squarish',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    icon: 'ri-football-line',
    description: 'Sports jerseys, team kits, and athletic wear in the spreadsheet.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20sports%20jersey%20display%20on%20warm%20cream%20background%2C%20athletic%20fabric%20texture%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20team%20colors%20subtle&width=200&height=200&seq=cat-jersey-v2&orientation=squarish',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    icon: 'ri-glasses-line',
    description: 'Watches, sunglasses, jewelry, and fashion accessories from verified sellers.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20accessories%20display%20with%20watch%20and%20glasses%20on%20warm%20cream%20background%2C%20soft%20lighting%2C%20modern%20editorial%20style%2C%20gold%20accents%2C%20sophisticated%20clean%20composition&width=200&height=200&seq=cat-accessories-v2&orientation=squarish',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    icon: 'ri-briefcase-line',
    description: 'Backpacks, handbags, crossbody bags, and luggage — find the best deals.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20handbag%20and%20backpack%20display%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20neutral%20brown%20and%20tan%20leather%20tones&width=200&height=200&seq=cat-bags-v2&orientation=squarish',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    icon: 'ri-link',
    description: 'Designer belts and casual belts at competitive prices.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20belt%20display%20on%20warm%20cream%20background%2C%20leather%20texture%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20brown%20and%20black%20classic%20style&width=200&height=200&seq=cat-belts-v2&orientation=squarish',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    icon: 'ri-drop-line',
    description: 'Fragrances and perfumes from popular brands, organized for easy browsing.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20perfume%20bottle%20display%20on%20warm%20cream%20background%2C%20soft%20lighting%2C%20modern%20editorial%20style%2C%20glass%20bottle%20with%20golden%20accents%2C%20sophisticated%20clean%20aesthetic&width=200&height=200&seq=cat-perfumes-v2&orientation=squarish',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    icon: 'ri-more-line',
    description: 'Everything else — home goods, gadgets, and miscellaneous finds.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20miscellaneous%20product%20display%20on%20warm%20cream%20background%2C%20gadgets%20and%20home%20items%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20organized%20neat%20composition&width=200&height=200&seq=cat-other-v2&orientation=squarish',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com/';

export const stats = [
  { value: '10,000+', label: 'Products Listed', icon: 'ri-shopping-bag-3-line' },
  { value: '500+', label: 'Verified Sellers', icon: 'ri-shield-check-line' },
  { value: 'Daily', label: 'Updated Spreadsheet', icon: 'ri-refresh-line' },
  { value: '14', label: 'Product Categories', icon: 'ri-grid-line' },
];

export const benefits = [
  {
    title: 'Save Time',
    description: 'Stop searching across multiple platforms. Everything is organized in one place so you find what you need in seconds.',
    icon: 'ri-timer-line',
  },
  {
    title: 'Find Trusted Sellers',
    description: 'Every seller in the spreadsheet has been verified by the AcBuy community, reducing the risk of scams.',
    icon: 'ri-shield-star-line',
  },
  {
    title: 'Compare Prices',
    description: 'See prices side by side across different sellers and make informed purchasing decisions quickly.',
    icon: 'ri-scales-3-line',
  },
  {
    title: 'Avoid Scams',
    description: 'With community-vetted links and updated information, you can shop with confidence and avoid fraudulent listings.',
    icon: 'ri-alert-line',
  },
  {
    title: 'Discover Best Products',
    description: 'Find hidden gems, trending items, and top-rated products that you might miss browsing manually.',
    icon: 'ri-sparkling-line',
  },
];

export const comparisonData = [
  { feature: 'Time Saving', acbuy: true, manual: false },
  { feature: 'Verified Sellers', acbuy: true, manual: false },
  { feature: 'Product Categories', acbuy: '14 Categories', manual: 'Limited' },
  { feature: 'Buying Guides', acbuy: true, manual: false },
  { feature: 'Safety Information', acbuy: true, manual: false },
  { feature: 'Community Reviews', acbuy: true, manual: false },
  { feature: 'Regular Updates', acbuy: 'Daily', manual: 'Rarely' },
  { feature: 'Price Comparison', acbuy: true, manual: 'Manual Only' },
];

export const faqs = [
  {
    question: 'What is AcBuy Spreadsheet?',
    answer: 'AcBuy Spreadsheet is a curated database that helps users discover products, trusted sellers, and shopping information. It organizes thousands of items across 14 categories, making it easy to find exactly what you are looking for without manually searching multiple platforms.',
  },
  {
    question: 'Is AcBuy Spreadsheet safe to use?',
    answer: 'Yes, AcBuy Spreadsheet is designed with safety in mind. However, users should always verify sellers individually and inspect QC photos before making purchases. The spreadsheet includes community-vetted links to reduce risk, but exercising personal caution is always recommended.',
  },
  {
    question: 'How often is the spreadsheet updated?',
    answer: 'The AcBuy Spreadsheet is updated daily with new products, seller information, and verified links. The community and spreadsheet maintainers work continuously to ensure the data remains accurate and relevant.',
  },
  {
    question: 'Can I access the spreadsheet for free?',
    answer: 'Yes, the AcBuy Spreadsheet is accessible to everyone. Simply visit the main website to browse the latest version and start exploring products across all categories.',
  },
  {
    question: 'How do I find specific products in the spreadsheet?',
    answer: 'The spreadsheet is organized by categories including Shoes, Hoodies, T-Shirts, Jackets, and more. You can use the category navigation on this page or directly browse the main website to filter and search for specific items.',
  },
];